import { useEffect, useState } from 'react';
import { authFetch } from '../../../utils/cloudFunctionsAuth';
import { CalendarCommitmentsResult } from './calendarCommitments';

export function useCalendarCommitments(from: string, to: string, revision: string) {
  const [state, setState] = useState<{ data: CalendarCommitmentsResult | null; loading: boolean; error: string | null }>({ data: null, loading: true, error: null });
  useEffect(() => {
    let active = true;
    let sequence = 0;
    let controller: AbortController | undefined;
    setState({ data: null, loading: true, error: null });
    const refresh = async () => {
      const request = ++sequence;
      controller?.abort();
      controller = new AbortController();
      try {
        const response = await authFetch('https://us-central1-web-construct-app.cloudfunctions.net/calendarCommitmentsHttp', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ from, to }), signal: controller.signal,
        });
        const data = await response.json();
        if (!response.ok || !data.ok || data.from !== from || data.to !== to || !Array.isArray(data.items) || !Array.isArray(data.replacedJobIds) || !data.errors || !data.warnings) {
          throw new Error(data.error || 'Support and payment dates could not be verified.');
        }
        if (active && request === sequence) setState({ data, loading: false, error: null });
      } catch (e) {
        if (active && request === sequence) setState({ data: null, loading: false, error: e instanceof Error ? e.message : 'Calendar commitments are unavailable.' });
      }
    };
    // Coalesce source updates and the initial range callback into one read.
    const initial = window.setTimeout(() => { void refresh(); }, 150);
    const onFocus = () => { if (!document.hidden) void refresh(); };
    window.addEventListener('focus', onFocus);
    const timer = window.setInterval(onFocus, 60000);
    return () => { active = false; controller?.abort(); window.clearTimeout(initial); window.clearInterval(timer); window.removeEventListener('focus', onFocus); };
  }, [from, to, revision]);
  return state;
}
